export default "__VITE_ASSET__DkJQTRnJ__"